import PropTypes from 'prop-types';
import React from 'react';
import TooltipV2 from 'ui/atoms/Tooltip/Tooltip';

// Adapter: maps the v1 API (aria, arrow, disabled) to the v2 API (ariaMode, hasArrow, isDisabled).
// The `variant` and `size` props were used by the chatbot but are not part of the Tooltip API — they are silently dropped.
function TooltipCustom({ aria, arrow, children, classes, disabled, leaveDelay, placement, title }) {
  return (
    <TooltipV2
      ariaMode={aria}
      classes={classes}
      hasArrow={arrow}
      isDisabled={disabled}
      leaveDelay={leaveDelay}
      placement={placement}
      title={title}
    >
      {children}
    </TooltipV2>
  );
}

TooltipCustom.propTypes = {
  aria: PropTypes.oneOf(['describedby', 'labelledby']),
  arrow: PropTypes.bool,
  children: PropTypes.element.isRequired,
  classes: PropTypes.object,
  disabled: PropTypes.bool,
  leaveDelay: PropTypes.number,
  placement: PropTypes.string,
  title: PropTypes.node.isRequired,
};

TooltipCustom.defaultProps = {
  aria: 'describedby',
  arrow: false,
  classes: {},
  disabled: false,
  leaveDelay: 0,
  placement: 'top',
};

export default TooltipCustom;
